/** Logo from company settings API — same path as Brand Identity */
export const getBrandingLogoFromSettings = (settingsResponse) =>
	settingsResponse?.data?.settings?.branding?.logo || '';

/** Logo from a full company document */
export const getCompanyLogoUrl = (company) =>
	company?.companySettings?.branding?.logo || null;
